module.exports = __webpack_public_path__ + "img/low-fat-gingerbread-cookies.40f02652.jpg";